export default __webpack_public_path__ + "a4682b30850a65566ea4c5b6abf5a6dd.png";